import { GetUserAchEntitlementsModelDto as BoUserAchEntitlementsModelDto } from '@treasury/api/bo';
import { GetUserAchEntitlementsModelDto as ConsumerUserAchEntitlementsModelDto } from '@treasury/api/channel';

import { DomainEntity } from '../../../../shared';
import { AchCompany } from '../../../entities/ach-company.entity';
import { UserClaim } from './user-claim.entity';

const defaultCompanyUserAchEntitlements: BoUserAchEntitlementsModelDto = {
    achCompanies: [],
    userAchCompanies: [],
    userProductClaims: [],
};

const templateFeatureIds = [95, 96, 97, 98, 99];
const paymentFeatureIds = [100, 101, 102, 103, 118, 133];
const internationalTemplateFeatureIds = [202, 203, 204, 205, 206];
const internationalPaymentFeatureIds = [185, 186, 187, 188, 189, 190];
const recipientFeatureIds = [138, 139, 140, 141];
const reviewFeatureIds = [194, 195];

export class CompanyUserAchEntitlements extends DomainEntity<
    BoUserAchEntitlementsModelDto | ConsumerUserAchEntitlementsModelDto
> {
    constructor(dto: BoUserAchEntitlementsModelDto | ConsumerUserAchEntitlementsModelDto) {
        super(dto);
        this.productClaims = this.dto.userProductClaims?.map(claim => new UserClaim(claim)) || [];
        this.achCompanies = this.dto.achCompanies?.map(company => new AchCompany(company)) || [];
    }

    public achCompanies: AchCompany[] = [];

    public productClaims: UserClaim[] = [];

    public get achTemplateFeatures() {
        return this.getClaimsById(templateFeatureIds);
    }

    public get achPaymentFeatures() {
        return this.getClaimsById(paymentFeatureIds);
    }

    public get internationalAchTemplateFeatures() {
        return this.getClaimsById(internationalTemplateFeatureIds);
    }

    public get internationalAchPaymentFeatures() {
        return this.getClaimsById(internationalPaymentFeatureIds);
    }

    public get recipientFeatures() {
        return this.getClaimsById(recipientFeatureIds);
    }

    public get reviewFeatures() {
        return this.getClaimsById(reviewFeatureIds);
    }

    public createDefault(): this {
        return new CompanyUserAchEntitlements(defaultCompanyUserAchEntitlements) as this;
    }

    private getClaimsById(ids: number[]) {
        return this.productClaims.filter(claim => ids.includes(claim.id));
    }
}
